import { Card } from '@material-ui/core'
import cx from 'clsx'
import { PropsWithChildren } from 'react'

interface QAPanelProps {
  className?: string
}

export function QAPanel({ children, className }: PropsWithChildren<QAPanelProps>) {
  return (
    <Card className={cx('faq-panel', className)} square>
      {children}
    </Card>
  )
}
